/* ============================================================
   Flow Intimates – Redesign JavaScript
   Reveal animations, announcement bar rotation, FAQ accordion,
   email popup, mobile drawer, header scroll, cart drawer (AJAX)
   ============================================================ */

(function() {
  'use strict';

  /* ── Reveal Animations (IntersectionObserver) ────────────── */
  function initReveals() {
    var els = document.querySelectorAll('.flow-reveal');
    if (!els.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      els.forEach(function(el) { el.classList.add('flow-reveal-in'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function() {
            entry.target.classList.add('flow-reveal-in');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Announcement Bar Rotation ───────────────────────────── */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-flow-announcement]');
    if (!bar) return;
    var messages = bar.querySelectorAll('[data-flow-announcement-msg]');
    if (messages.length < 2) return;
    var index = 0;
    messages.forEach(function(msg, i) {
      msg.style.display = i === 0 ? '' : 'none';
    });
    var interval = parseInt(bar.getAttribute('data-flow-announcement-interval') || '4500', 10);
    setInterval(function() {
      messages[index].style.display = 'none';
      index = (index + 1) % messages.length;
      messages[index].style.display = '';
      messages[index].classList.remove('flow-fade-in');
      void messages[index].offsetWidth; // force reflow
      messages[index].classList.add('flow-fade-in');
    }, interval);
  }

  /* ── FAQ Accordion ───────────────────────────────────────── */
  function initAccordions() {
    document.querySelectorAll('.flow-accordion').forEach(function(accordion) {
      var items = accordion.querySelectorAll('.flow-accordion__item');
      items.forEach(function(item) {
        var trigger = item.querySelector('.flow-accordion__trigger');
        if (!trigger) return;
        trigger.addEventListener('click', function() {
          var isOpen = item.classList.contains('is-open');
          // Close all in this accordion
          items.forEach(function(it) { it.classList.remove('is-open'); });
          // Toggle current
          if (!isOpen) {
            item.classList.add('is-open');
          }
          // Update aria
          items.forEach(function(it) {
            var btn = it.querySelector('.flow-accordion__trigger');
            if (btn) btn.setAttribute('aria-expanded', it.classList.contains('is-open'));
          });
          // Update +/- icons
          items.forEach(function(it) {
            var plus = it.querySelector('.flow-accordion__icon-plus');
            var minus = it.querySelector('.flow-accordion__icon-minus');
            if (plus && minus) {
              if (it.classList.contains('is-open')) {
                plus.style.display = 'none';
                minus.style.display = '';
              } else {
                plus.style.display = '';
                minus.style.display = 'none';
              }
            }
          });
        });
      });
    });
  }

  /* ── Header Scroll Behavior ──────────────────────────────── */
  function initHeaderScroll() {
    var header = document.querySelector('[data-flow-header]');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 24) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile Drawer ───────────────────────────────────────── */
  function initMobileDrawer() {
    var drawer = document.querySelector('[data-flow-mobile-drawer]');
    if (!drawer) return;
    var openBtn = document.querySelector('[data-flow-burger]');
    var closeBtn = drawer.querySelector('[data-flow-mobile-close]');
    var overlay = drawer.querySelector('.flow-mobile-drawer__overlay');
    var links = drawer.querySelectorAll('a');

    function openDrawer() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    links.forEach(function(link) {
      link.addEventListener('click', closeDrawer);
    });
  }

  /* ── Cart Drawer (Shopify AJAX Cart) ─────────────────────── */
  var FlowCart = {
    drawer: null,
    threshold: 100,

    init: function() {
      this.drawer = document.querySelector('[data-flow-cart-drawer]');
      if (!this.drawer) return;

      var self = this;
      this.threshold = parseInt(this.drawer.getAttribute('data-free-shipping') || '100', 10);

      // Open/close
      document.querySelectorAll('[data-flow-cart-open]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          self.open();
        });
      });
      var closeBtn = this.drawer.querySelector('[data-flow-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', function() { self.close(); });
      var overlay = this.drawer.querySelector('.flow-cart-drawer__overlay');
      if (overlay) overlay.addEventListener('click', function() { self.close(); });

      // Delegate clicks on qty/remove buttons
      this.drawer.addEventListener('click', function(e) {
        var target = e.target.closest('[data-cart-action]');
        if (!target) return;
        var action = target.getAttribute('data-cart-action');
        var key = target.getAttribute('data-cart-key');
        var qty = parseInt(target.getAttribute('data-cart-qty') || '0', 10);

        if (action === 'plus') self.updateItem(key, qty + 1);
        else if (action === 'minus') self.updateItem(key, Math.max(0, qty - 1));
        else if (action === 'remove') self.updateItem(key, 0);
        else if (action === 'upsell-add') self.addUpsell(target);
      });

      // Listen for custom event from add-to-cart forms
      document.addEventListener('flow:cart:added', function() {
        self.refresh();
        self.open();
      });

      // Initial count
      this.refreshCount();
    },

    open: function() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close: function() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    refresh: function() {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { self.render(cart); })
        .catch(function(err) { console.error('Cart fetch error:', err); });
    },

    refreshCount: function() {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { self.updateCountBadge(cart.item_count); })
        .catch(function() {});
    },

    updateItem: function(key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          self.render(cart);
          self.updateCountBadge(cart.item_count);
        })
        .catch(function(err) { console.error('Cart update error:', err); });
    },

    addUpsell: function(btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function(r) { return r.json(); })
        .then(function() { self.refresh(); self.refreshCount(); })
        .catch(function(err) { console.error('Cart add error:', err); });
    },

    updateCountBadge: function(count) {
      document.querySelectorAll('[data-flow-cart-count]').forEach(function(badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      });
    },

    formatMoney: function(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    },

    render: function(cart) {
      if (!this.drawer) return;
      var self = this;
      var body = this.drawer.querySelector('[data-flow-cart-body]');
      var foot = this.drawer.querySelector('[data-flow-cart-foot]');
      var shippingText = this.drawer.querySelector('[data-flow-cart-shipping-text]');
      var shippingBar = this.drawer.querySelector('[data-flow-cart-shipping-progress]');

      // Shipping bar
      var remaining = Math.max(0, (this.threshold * 100) - cart.total_price);
      var progress = Math.min(100, (cart.total_price / (this.threshold * 100)) * 100);
      if (shippingText) {
        shippingText.textContent = remaining > 0
          ? "You're " + self.formatMoney(remaining) + " away from free shipping"
          : "Free AU shipping unlocked";
      }
      if (shippingBar) {
        shippingBar.style.width = progress + '%';
      }

      this.updateCountBadge(cart.item_count);

      // Render items
      if (!body) return;
      if (cart.items.length === 0) {
        body.innerHTML = '<div class="flow-cart-drawer__empty">'
          + '<p>Your cart is empty for now.</p>'
          + '<a href="/collections/all" class="flow-btn-primary" style="margin-top:1.25rem;">Shop period underwear</a>'
          + '</div>';
        if (foot) foot.style.display = 'none';
        return;
      }

      var html = '<ul class="flow-cart-drawer__items">';
      cart.items.forEach(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
        var variantTitle = item.variant_title || '';
        html += '<li class="flow-cart-drawer__item">';
        html += '<div class="flow-cart-drawer__item-img">';
        if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">';
        html += '</div>';
        html += '<div class="flow-cart-drawer__item-info">';
        html += '<p class="flow-cart-drawer__item-name">' + item.product_title + '</p>';
        if (variantTitle) html += '<p class="flow-cart-drawer__item-variant">' + variantTitle + '</p>';
        html += '<div class="flow-cart-drawer__item-actions">';
        html += '<div class="flow-cart-drawer__qty">';
        html += '<button type="button" class="flow-cart-drawer__qty-btn" data-cart-action="minus" data-cart-key="' + item.key + '" data-cart-qty="' + item.quantity + '" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
        html += '<span class="flow-cart-drawer__qty-val">' + item.quantity + '</span>';
        html += '<button type="button" class="flow-cart-drawer__qty-btn" data-cart-action="plus" data-cart-key="' + item.key + '" data-cart-qty="' + item.quantity + '" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
        html += '</div>';
        html += '<button type="button" class="flow-cart-drawer__remove-btn" data-cart-action="remove" data-cart-key="' + item.key + '">Remove</button>';
        html += '</div></div>';
        html += '<div class="flow-cart-drawer__item-price">';
        html += '<p class="flow-cart-drawer__item-price-current">' + self.formatMoney(item.final_line_price) + '</p>';
        if (item.original_line_price > item.final_line_price) {
          html += '<p class="flow-cart-drawer__item-price-compare">' + self.formatMoney(item.original_line_price) + '</p>';
        }
        html += '</div></li>';
      });
      html += '</ul>';

      body.innerHTML = html;

      // Footer
      if (foot) {
        foot.style.display = '';
        var savingsEl = foot.querySelector('[data-flow-cart-savings]');
        var subtotalEl = foot.querySelector('[data-flow-cart-subtotal]');
        var checkoutBtn = foot.querySelector('[data-flow-cart-checkout-btn]');
        var totalSavings = cart.original_total_price - cart.total_price;

        if (savingsEl) {
          if (totalSavings > 0) {
            savingsEl.style.display = '';
            savingsEl.textContent = "You're saving " + self.formatMoney(totalSavings);
          } else {
            savingsEl.style.display = 'none';
          }
        }
        if (subtotalEl) subtotalEl.textContent = self.formatMoney(cart.total_price);
        if (checkoutBtn) checkoutBtn.textContent = 'Checkout · ' + self.formatMoney(cart.total_price);
      }
    }
  };

  /* ── Email Popup ─────────────────────────────────────────── */
  function initEmailPopup() {
    var popup = document.querySelector('[data-flow-popup]');
    if (!popup) return;

    var KEY = 'flow-popup-dismissed-at';
    var THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

    // Check if dismissed recently
    var dismissed = 0;
    try { dismissed = Number(localStorage.getItem(KEY) || 0); } catch(e) {}
    if (dismissed && (Date.now() - dismissed) < THIRTY_DAYS) return;

    var fired = false;
    function show() {
      if (fired) return;
      fired = true;
      popup.classList.add('is-open');
    }

    // Timer trigger
    var timer = setTimeout(show, 12000);

    // Scroll trigger
    function onScroll() {
      var scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight || 1);
      if (scrolled > 0.4) show();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Exit intent (desktop)
    function onLeave(e) {
      if (e.clientY <= 0 && window.innerWidth >= 1024) show();
    }
    document.addEventListener('mouseout', onLeave);

    // Dismiss
    function dismiss() {
      try { localStorage.setItem(KEY, String(Date.now())); } catch(e) {}
      popup.classList.remove('is-open');
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
    }

    popup.querySelectorAll('[data-flow-popup-close]').forEach(function(btn) {
      btn.addEventListener('click', dismiss);
    });
    var overlay = popup.querySelector('.flow-popup__overlay');
    if (overlay) overlay.addEventListener('click', dismiss);

    // Form submit
    var form = popup.querySelector('[data-flow-popup-form]');
    var formView = popup.querySelector('[data-flow-popup-form-view]');
    var successView = popup.querySelector('[data-flow-popup-success]');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (formView) formView.style.display = 'none';
        if (successView) successView.style.display = '';
      });
    }
  }

  /* ── Intercept Add to Cart forms ─────────────────────────── */
  function initAddToCartForms() {
    document.querySelectorAll('form[data-flow-atc]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(val, key) { data[key] = val; });

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(data.id, 10), quantity: parseInt(data.quantity || '1', 10) })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('flow:cart:added'));
          })
          .catch(function(err) { console.error('Add to cart error:', err); });
      });
    });
  }

  /* ── Initialize Everything ───────────────────────────────── */
  function init() {
    initReveals();
    initAnnouncementBar();
    initAccordions();
    initHeaderScroll();
    initMobileDrawer();
    FlowCart.init();
    initEmailPopup();
    initAddToCartForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init reveals after Shopify section rendering (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initReveals();
      initAccordions();
      initAnnouncementBar();
    });
  }

})();
